module.exports = __webpack_public_path__ + "static/media/bachelor.f33d0dcb.jpeg";